































import { Component, Mixins } from "vue-property-decorator";
import CalendarMixin from "./CalendarMIxin";
import { endOfDay, trunc } from "../../date-picker/private/Utils";

@Component
export default class CalendarDayView extends Mixins(CalendarMixin) {
    private get titleDay() {
        this.$emit("new-range", [trunc(this.refDate), endOfDay(this.refDate)]);
        const today = trunc(new Date());
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const ref = trunc(new Date(this.refDate));

        if (ref.getTime() === today.getTime()) {
            return this.$t("today");
        } else if (ref.getTime() === yesterday.getTime()) {
            return this.$t("yesterday");
        } else if (ref.getTime() === tomorrow.getTime()) {
            return this.$t("tomorrow");
        }

        return `${this.refDate.getDate()}`;
    }
    private get titleOther() {
        this.$emit("new-range", [trunc(this.refDate), endOfDay(this.refDate)]);
        const today = trunc(new Date());
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const ref = trunc(new Date(this.refDate));

        if (
            ref.getTime() === today.getTime() ||
            ref.getTime() === yesterday.getTime() ||
            ref.getTime() === tomorrow.getTime()
        ) {
            return "";
        } else {
            return `${this.$t(this.monthName)} ${this.refDate.getFullYear()}`;
        }
    }
}
